import * as jsxRuntime from "/dev/shm/repo/olerdb-40nfvuozo5/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment